function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';


  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }


  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }


  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];

    if (!first || !last) return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('keydown', trapFocusHandlers.keydown);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl?.getAttribute('data-default');
    if (value && this.provinceEl?.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {

    
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      if(this.provinceContainer != null){
        this.provinceContainer.style.display = 'none';
      }
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl?.appendChild(opt);
      }

      if(this.provinceContainer != null){
        this.provinceContainer.style.display = '';
      }
      
    }
  },

  clearOptions: function (selector) {
    while (selector?.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('.menu-drawer__close-button, .mobile-facets__close-button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement?.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement?.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement?.classList.remove('menu-opening');
    detailsElement?.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement?.closest('details[open]')) {
          trapFocus(detailsElement?.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

}
customElements.define('header-menu-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class HotSpot extends HTMLElement {
  constructor() {
    super();
    this.sliderItem = null;
    this.itemsRound = [];
  }

  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  priceCalculation() {
    const productItems = this.querySelectorAll('.hotpot_slider_item');
    let totalPrice = 0;

    productItems.forEach((product) => {
      totalPrice += parseInt(product.dataset.price);
    });

    const subTotal = this.querySelector('.hotspot-subtotal');

    if (subTotal && typeof Shopify.formatMoney === 'function') {
      subTotal.innerHTML = Shopify.formatMoney(totalPrice);
    }
  }

  activateHotspot(item, index) {
    this.itemsRound.forEach((ins) => {
      ins.classList.remove('active');
      ins.setAttribute('aria-expanded', 'false');
    });

    this.sliderItem?.flickity?.select(index);

    item.classList.add('active');
    item.setAttribute('aria-expanded', 'true');
  }

  setupHotspotAccessibility() {
    this.itemsRound.forEach((item, index) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');

      const title = item.querySelector('.hotspot-popup p:first-child')?.textContent?.trim();
      item.setAttribute('aria-label', title ? `Show ${title}` : `Show hotspot ${index + 1}`);

      item.addEventListener('click', () => {
        this.activateHotspot(item, index);
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.activateHotspot(item, index);
        }
      });
    });
  }

  init() {
    this.priceCalculation();

    this.sliderItem = this.querySelector('items-carousel');
    this.itemsRound = this.querySelectorAll('.bulk_hotspot_images .hotspot');

    const bulkBtn = this.querySelector('.bulk-hotspot-btn');

    if (bulkBtn) {
      bulkBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const btn = e.currentTarget;
        const loader = btn.querySelector('.hotspot-btn-loader');
        const textContent = btn.firstElementChild;

        if (loader) loader.style.display = 'block';
        if (textContent) textContent.style.display = 'none';

        const itemsToAdd = [];
        const productItems = this.querySelectorAll('.hotpot_slider_item');

        productItems.forEach((product) => {
          const variantId = product.dataset.variantId;

          if (variantId) {
            itemsToAdd.push({
              id: parseInt(variantId),
              quantity: 1,
            });
          }
        });

        const errorSpan = btn.parentNode.querySelector('.bulk-hotspot-error-message');
        if (errorSpan) errorSpan.innerText = '';

        if (itemsToAdd.length === 0) {
          if (loader) loader.style.display = 'none';
          if (textContent) textContent.style.display = 'block';
          return;
        }

        const formData = {
          items: itemsToAdd,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        };

        const route =
          window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js';

        fetch(route, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description);
              if (errorSpan) errorSpan.innerText = response.description;
              return;
            }

            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer && response.sections) {
              cartDrawer.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (loader) loader.style.display = 'none';
            if (textContent) textContent.style.display = 'block';
          });
      });
    }

    setTimeout(() => {
      this.setupHotspotAccessibility();
    }, 100);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('hot-spot', HotSpot);
});



class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class ModalOpenerButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    const btnIsQick = button.classList.contains('quick-view-prg-have');
    if (!btnIsQick) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('popup-slide', ModalOpenerButton);



class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    if (event?.target && typeof event.target.select === 'function') {
      event.target.select();
    }
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}



document.querySelectorAll('[id^="Details-"]').forEach((detailsElement) => {
  const summary = detailsElement.querySelector('summary');

  if (!summary) return;

  summary.setAttribute('role', 'button');

  detailsElement.addEventListener('mouseenter', () => {
    summary.setAttribute('aria-expanded', 'true');
  });

  detailsElement.addEventListener('mouseleave', () => {
    summary.setAttribute('aria-expanded', 'false');
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const disclosureButtons = document.querySelectorAll(".menu-drawer-footer .disclosure__button");
  const listWrappers = document.querySelectorAll(".menu-drawer-footer .disclosure__list-wrapper");

  disclosureButtons.forEach((button, index) => {
      const listWrapper = listWrappers[index];

      if (listWrapper) {
          button.addEventListener("click", function (event) {
              event.stopPropagation(); 
              const isOpen = listWrapper.classList.contains("open");

              listWrappers.forEach(wrapper => wrapper.classList.remove("open"));

              if (!isOpen) {
                  listWrapper.classList.add("open");
              }
              this.classList.toggle('active')
          });
      }
  });

  document.addEventListener("click", function () {
    disclosureButtons.forEach((button) => button.classList.remove("active"))
      listWrappers.forEach(wrapper => wrapper.classList.remove("open")); 
  });
});



class ResponsiveDropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.menuBtn = null;
    this.menuList = null;

    this.resizeHandler = this.handleResize.bind(this);
    this.toggleHandler = this.toggleMenu.bind(this);
    this.keydownHandler = this.onMenuKeyDown.bind(this);
  }

  connectedCallback() {
    this.menuBtn = this.querySelector('.menu-btn');
    this.menuList = this.querySelector('.menu-list');

    if (!this.menuBtn || !this.menuList) return;

    window.addEventListener('resize', this.resizeHandler);
    this.handleResize();
  }

  handleResize() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;

    if (isMobile) {
      this.enableDropdown();
    } else {
      this.disableDropdown();
    }
  }

  enableDropdown() {
    this.menuBtn.removeEventListener('click', this.toggleHandler);
    this.menuBtn.removeEventListener('keydown', this.keydownHandler);
    this.menuBtn.addEventListener('click', this.toggleHandler);
    this.menuBtn.addEventListener('keydown', this.keydownHandler);

    this.menuList.style.height = '0';
    this.menuList.style.opacity = '0';
    this.menuList.style.overflow = 'hidden';
    this.menuList.setAttribute('inert', '');
    this.menuList.setAttribute('aria-hidden', 'true');
    this.menuBtn.setAttribute('role', 'button');
    this.menuBtn.setAttribute('tabindex', '0');
    this.menuBtn.setAttribute('aria-expanded', 'false');
    this.menuBtn.setAttribute('aria-controls', this.menuList.id);
    this.menuBtn.classList.remove('menu-list-open');
  }

  disableDropdown() {
    this.menuBtn.removeEventListener('click', this.toggleHandler);
    this.menuBtn.removeEventListener('keydown', this.keydownHandler);

    this.menuList.style.height = 'auto';
    this.menuList.style.opacity = '1';
    this.menuList.style.overflow = '';
    this.menuList.removeAttribute('inert');
    this.menuList.removeAttribute('aria-hidden');
    this.menuBtn.removeAttribute('role');
    this.menuBtn.removeAttribute('tabindex');
    this.menuBtn.removeAttribute('aria-expanded');
    this.menuBtn.removeAttribute('aria-controls');
    this.menuBtn.classList.remove('menu-list-open');
  }

  onMenuKeyDown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.toggleMenu();
  }

  toggleMenu() {
    const isOpen = this.menuBtn.classList.contains('menu-list-open');

    if (!isOpen) {
      this.menuList.style.height = this.menuList.scrollHeight + 'px';
      this.menuList.style.opacity = '1';
      this.menuList.removeAttribute('inert');
      this.menuList.setAttribute('aria-hidden', 'false');
      this.menuBtn.setAttribute('aria-expanded', 'true');
      this.menuBtn.classList.add('menu-list-open');
    } else {
      this.menuList.style.height = '0';
      this.menuList.style.opacity = '0';
      this.menuList.setAttribute('inert', '');
      this.menuList.setAttribute('aria-hidden', 'true');
      this.menuBtn.setAttribute('aria-expanded', 'false');
      this.menuBtn.classList.remove('menu-list-open');
    }
  }

  disconnectedCallback() {
    if (this.menuBtn) {
      this.menuBtn.removeEventListener('click', this.toggleHandler);
      this.menuBtn.removeEventListener('keydown', this.keydownHandler);
    }
    window.removeEventListener('resize', this.resizeHandler);
  }
}

if (!customElements.get('responsive-dropdown-menu')) {
  customElements.define('responsive-dropdown-menu', ResponsiveDropdownMenu);
}




document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get("items-carousel")) {
      customElements.define("items-carousel", class extends HTMLElement {
          constructor() { super(); }
          connectedCallback() {
              this.laSC = window.scrollY
              this.cstmBtn = this.classList.contains('have-custom-btn')
              this.cstmDots = this.querySelector('.dots-slider-area-custom');
              this.ProgressBar = this.querySelector('.custom-scroll-bar-slider');
              this.theCarousel = this.querySelector('.items-carousel-selector');
              const flickityData = this.theCarousel.getAttribute("data-flickity");
              const flickityOptions = flickityData ? JSON.parse(flickityData) : {};
              this.initialize(flickityOptions);
              if(this.theCarousel.classList.contains('motions-scroll-css')){
                this.scrollMove();
              }
          }
          scrollMove() {
            if (this._scrollBound) return;
            this._scrollBound = true;
          
            this._onScroll = () => {
              if (!this.flickity) return;
          
              this.flickity.isFreeScrolling = true;
              this.flickity.startAnimation();
          
              const diff = window.scrollY - this.laSC;
              this.laSC = window.scrollY;
          
              this.flickity.velocity += diff * -0.1;
              this.flickity.x += this.flickity.velocity;
              this.flickity.velocity *= 0.5;
          
              this.flickity.positionSlider();
            };
          
            window.addEventListener('scroll', this._onScroll, { passive: true });
          }
          
          reHap() {
              if (this.flickity && this.flickity.cells && this.flickity.selectedElements) {
                  if (this.flickity.selectedElements.length >= this.flickity.cells.length) {
                      this.flickity.options.draggable = false;
                  } else {
                      this.flickity.options.draggable = true;
                  }
                  this.flickity.updateDraggable();
                  this.flickity.resize();
              }
          }
          customPrevNext() {
            if (!this.cstmBtn || !this.flickity) return;
          
            const prevBtn = this.querySelector(
              '.custom-next-prev-btn[aria-label="Previous"]'
            );
            const nextBtn = this.querySelector(
              '.custom-next-prev-btn[aria-label="Next"]'
            );
          
            const updateButtons = () => {
              const index = this.flickity.selectedIndex;
              const lastIndex = this.flickity.slides.length - 1;
              prevBtn.classList.toggle('disabled', index === 0);
              nextBtn.classList.toggle('disabled', index === lastIndex);
            };
          
            prevBtn.addEventListener('click', () => {
              if (!prevBtn.classList.contains('disabled')) {
                this.flickity.previous();
              }
            });
          
            nextBtn.addEventListener('click', () => {
              if (!nextBtn.classList.contains('disabled')) {
                this.flickity.next();
              }
            });
            updateButtons();
            this.flickity.on('change', updateButtons);
          }
          resetScrollPhysics() {
            if (!this.flickity) return;
            this.laSC = window.scrollY;
            this.flickity.velocity = 0;
            this.flickity.isFreeScrolling = true;
            this.flickity.x = this.flickity.x || 0;
            this.flickity.positionSlider();
          }
          
          customDots() {
            if (!this.flickity) return;
            if (!this.cstmDots) return;
          
            const allDots = this.querySelectorAll('.slide-dot-button');
            const slides = this.theCarousel.querySelectorAll('.slider_item');
          
            if (!allDots.length || !slides.length) return;
          
            const clearAllDots = () => {
              allDots.forEach(dot => dot.classList.remove('is-active'));
            };
          
            const activateDotsForSlide = (index) => {
              const realIndex = index % slides.length;
              const activeSlide = slides[realIndex];
              if (!activeSlide) return;
          
              const dotsInSlide = activeSlide.querySelectorAll('.slide-dot-button');
              if (!dotsInSlide.length) return;
          
              dotsInSlide.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === realIndex);
              });

            };
          
        
            clearAllDots();
            activateDotsForSlide(this.flickity.selectedIndex);
          
            this.flickity.on('change', index => {
              clearAllDots();
              activateDotsForSlide(index);
            });
          }
          
          
          initialize(options) {
              if (this.theCarousel && this.theCarousel.offsetParent !== null) {
                  this.theCarousel.style.display = "block";
                  const defaultOptions = { "autoplay": false };
                  const mergedOptions = { ...defaultOptions, ...options };
                  this.flickity = new Flickity(this.theCarousel, mergedOptions);
                  this.customPrevNext();
                  this.customDots();

                  this.flickity.on('ready', () => { this.reHap(); });
     
                  if(this.ProgressBar != null){
                    this.flickity.on( 'scroll', ( progress ) => {
                      progress = Math.max( 0, Math.min( 1, progress ) );
                      this.ProgressBar.querySelector('span').style.width = progress * 100 + '%';
                    });  
                  }


                  window.addEventListener('resize', () => {
                    requestAnimationFrame(() => {
                      this.reHap();
                  
                      if (this.theCarousel.classList.contains('motions-scroll-css')) {
                        this.resetScrollPhysics();
                      }
                    });
                  });

                  Shopify.designMode && this.addEventListener("shopify:block:select", event => {
                      if (this.flickity) {
                          this.flickity.destroy();
                          this.flickity = null;
                      }
                      this.initialize(JSON.parse(this.theCarousel.getAttribute("data-flickity") || '{}'));
                      const slideIndex = [...event.target.parentElement.childNodes].indexOf(event.target);
                      setTimeout(() => {
                          if(this.flickity) this.flickity.select(slideIndex, true);
                      }, 200);
                  });
                  Shopify.designMode && this.addEventListener("shopify:block:deselect", () => {
                      if (this.flickity) this.flickity.playPlayer();
                  });
                  this.flickity.on("change", index => {

                  });
              }
          }
      });
  }
});


function observeAnimItems() {
  const wrappers = document.querySelectorAll('.anim-wrapper');

  wrappers.forEach(wrapper => {
    const items = wrapper.querySelectorAll('.anim-item:not(.reveal)');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('reveal');
          }, index * 100);
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });

    items.forEach(item => observer.observe(item));
  });
}
document.addEventListener("DOMContentLoaded", observeAnimItems);
document.addEventListener("shopify:section:load", observeAnimItems);


if (!customElements.get('renders-sub-popup')) {
  customElements.define(
    'renders-sub-popup',
    class extends HTMLElement {
      constructor() {
        super();
        this.cBtn = this.querySelector('[data-close="close-btn"]');
        this.testMode = this.getAttribute('mode');
        this.delay = parseInt(this.getAttribute('delay'));
        this.expiry = parseInt(this.getAttribute('expiry'));
        this.cookieName = 'snazzy:newsletter-popup';
        this.cBtn.addEventListener('click', this.afterHide.bind(this));
      }
      connectedCallback() {
        this.init();
      }
      init() {
        Shopify?.designMode
          ? this.testMode == 'true' && this.load(0)
          : !this.getCookie(this.cookieName) && this.load(this.delay);
      }
      load(delay) {
        setTimeout(() => this.show(), delay * 1000);
      }
      show() {
        this.classList.add('active');
        setTimeout(() => this.afterShow(), 500);
      }
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
      afterShow() {
        this.classList.add('image-show');
      }
      afterHide() {
        this.classList.remove('image-show');
        setTimeout(() => this.classList.remove('active'), 1000);
        if (this.testMode == 'true') {
          this.removeCookie(this.cookieName);
          return;
        }
        this.setCookie(this.cookieName, this.expiry);
      }
    }
  );
}

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const accordionButtons = document.querySelectorAll('.accordion button');

if (accordionButtons.length > 0) {
  const firstButton = accordionButtons[0];
  const firstContent = firstButton.nextElementSibling;
  firstButton.setAttribute('aria-expanded', 'true');
  firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
}

accordionButtons.forEach(button => {
  button.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    const content = this.nextElementSibling;

    accordionButtons.forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const c = btn.nextElementSibling;
      c.style.maxHeight = null;
      c.classList.remove('active');
    });

    if (!expanded) {
      this.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('active');
    }
  });
});

  }
}

function initAccordions(scope = document) {
  const titles = scope.querySelectorAll('.accordion-title');
  titles.forEach(title => {
    title.addEventListener('click', () => {
      const item = title.parentElement;
      item.classList.toggle('show');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAccordions();
});

document.addEventListener('shopify:section:load', (event) => {
  initAccordions(event.target);
});


const backToTop = document.getElementById('back-to-top');
if (backToTop) {
  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}


  const countries = window.allCountryOptionTags || [];

  window.initializeShippingEstimator = function initializeShippingEstimator(containerElement) {
    if (!containerElement || containerElement.dataset.shippingEstimatorInitialized === 'true') return;

    const countrySelect = containerElement.querySelector('.shipping-country-select');
    const provinceSelect = containerElement.querySelector('.shipping-province-select');
    const zipInput = containerElement.querySelector('.shipping-zip-input');
    const estimateBtn = containerElement.querySelector('.estimate-shipping-btn');
    const resultDiv = containerElement.querySelector('.shipping-rates-result');
    const provinceWrapper = containerElement.querySelector('.shipping-province-wrapper');

    if (!countrySelect || !zipInput || !estimateBtn || !resultDiv) return;

    containerElement.dataset.shippingEstimatorInitialized = 'true';

    estimateBtn.disabled = true;

    function validateInputs() {
      const country = countrySelect.value;
      const zip = zipInput.value.trim();
      estimateBtn.disabled = !(country && zip);
    }

    countrySelect.addEventListener('change', () => {
      validateInputs();
      fetch(`/meta.json`)
        .finally(() => {
          if (Shopify.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector(
              countrySelect.id, 
              provinceSelect?.id,
              { hideElement: provinceWrapper?.id }
            );
          }
        });
    });

    zipInput.addEventListener('input', validateInputs);

    countrySelect.dispatchEvent(new Event('change'));

    estimateBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const country = countrySelect.value;
      const province = provinceSelect?.value;
      const zip = zipInput.value.trim();

      resultDiv.classList.remove("shipping-result-success", "shipping-result-error"); 
      resultDiv.classList.add("shipping-result-show");
      resultDiv.textContent = 'Loading shipping rates...';

      const data = new URLSearchParams();
      data.append('shipping_address[country]', country);
      if (province) data.append('shipping_address[province]', province);
      data.append('shipping_address[zip]', zip);

      fetch('/cart/shipping_rates.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data.toString()
      })
      .then(response => response.json())
      .then(data => {
        if (data.shipping_rates?.length > 0) {
          const ratesHtml = data.shipping_rates.map(rate =>
            `<div class="rate-item"><strong>${rate.name}</strong>: ${rate.price} ${rate.currency}</div>`
          ).join('');
          resultDiv.innerHTML = `<p>Available Shipping Rates:</p>${ratesHtml}`;
          resultDiv.classList.add("shipping-result-success");
        } else {
          resultDiv.textContent = 'No shipping rates available for this location.';
          resultDiv.classList.add("shipping-result-error");
        }
      })
      .catch(() => {
        resultDiv.textContent = 'Error fetching shipping rates.';
        resultDiv.classList.add("shipping-result-error"); 
      });
    });
  }
document.addEventListener('DOMContentLoaded', function () {
  const estimatorContainers = document.querySelectorAll('.shipping-estimator-container');
  estimatorContainers.forEach(container => {
    window.initializeShippingEstimator(container);
  });
});



function setupCornerRoundWatcher() {
  document.querySelectorAll(".corner-round").forEach((el) => {
    el.closest(".shopify-section")?.classList.add("mt-minus");
  });
}
document.addEventListener('DOMContentLoaded', setupCornerRoundWatcher);
document.addEventListener('shopify:section:load', setupCornerRoundWatcher);
document.addEventListener('shopify:section:select', setupCornerRoundWatcher);


function applyOverlayHeaderClass() {
  const header = document.querySelector(".snazzy-header.overlay-header");
  const sectionHeader = document.querySelector(".section-header");

  if (header && sectionHeader) {
    sectionHeader.classList.add("overlay-header-active");
  }
}

document.addEventListener("DOMContentLoaded", applyOverlayHeaderClass);

document.addEventListener("shopify:section:load", applyOverlayHeaderClass);
document.addEventListener("shopify:section:select", applyOverlayHeaderClass);
document.addEventListener("shopify:section:deselect", applyOverlayHeaderClass);
document.addEventListener("shopify:block:select", applyOverlayHeaderClass);
document.addEventListener("shopify:block:deselect", applyOverlayHeaderClass);



document.addEventListener('DOMContentLoaded', function() {


  const ignoreSelectors = [
    '#Cart-note',
    '.shipping-estimator input',
    '.shipping-estimator select'
  ];
  
  ignoreSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      ['change', 'input'].forEach(evt => {
        el.addEventListener(evt, e => e.stopPropagation());
      });
    });
  });


});



class ThirdLvl extends HTMLElement {
  constructor() {
    super();

    this.trigger = null;       
    this.childMenu = null;    
    this.icon = null;         

    this.toggleMenu = this.toggleMenu.bind(this);
    this.onTriggerKeyDown = this.onTriggerKeyDown.bind(this);
  }

  connectedCallback() {
    const linkedLabel = this.querySelector(":scope > a.menu-drawer__menu-item[href]");
    const toggleButton = this.querySelector(":scope > .third-level-menu-toggle");
    const buttonTrigger = this.querySelector(':scope > .menu-drawer__menu-item[role="button"]');

    this.trigger = linkedLabel ? toggleButton : buttonTrigger;
    this.childMenu = this.querySelector(":scope > [id^='childlink-']");
    this.icon = this.trigger?.querySelector(".icon-caret");

    if (this.trigger) {
      this.trigger.addEventListener("click", this.toggleMenu);
      if (this.trigger.tagName !== "BUTTON") {
        this.trigger.addEventListener("keydown", this.onTriggerKeyDown);
      }
    } 
  }

  onTriggerKeyDown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    this.toggleMenu(event);
  }

  toggleMenu(event) {
    event?.preventDefault();
    event?.stopPropagation();

    const isOpen = this.childMenu?.classList.toggle("open");
    this.trigger?.setAttribute("aria-expanded", isOpen ? "true" : "false");

    if (this.icon) {
      this.icon.style.transform = isOpen ? "rotate(180deg)" : "rotate(0deg)";
      this.icon.style.transition = "transform 0.3s ease";
    }

    this.dispatchEvent(new CustomEvent("thirdlevel-toggle", {
      detail: { open: isOpen },
      bubbles: true
    }));
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener("click", this.toggleMenu);
      this.trigger.removeEventListener("keydown", this.onTriggerKeyDown);
    }
  }
}
if (!customElements.get("thrid-lvl")) {
  customElements.define("thrid-lvl", ThirdLvl);
}
